import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { utils } from '@atlaskit/util-service-support';
import { MarkRequestReadState, ProductFilters } from '@atlassian/notification-common/types';
import { packageName, packageVersion } from '../constants';
import { getTimeRange } from '../time-range-utils';
export var markAllApiRoute = '/gateway/api/notification-log/api/3/notifications/mark';
export var markAllNotificationsReadFetch = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(direct, afterInclusive, filters) {
    var _filters$includeActor, _filters$excludeActor;
    var timeRangeFilter, timestamps, requestServiceOptions;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          timeRangeFilter = filters !== null && filters !== void 0 && filters.timeRangeFilter ? filters.timeRangeFilter : 'all';
          timestamps = getTimeRange(timeRangeFilter);
          requestServiceOptions = {
            queryParams: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
              direct: direct,
              afterInclusive: afterInclusive
            }, filters && filters.productFilter !== ProductFilters.ANY && {
              product: filters.productFilter
            }), timestamps.endTimestamp && {
              beforeTimestamp: timestamps.endTimestamp
            }), timestamps.startTimestamp && {
              afterTimestamp: timestamps.startTimestamp
            }), (filters === null || filters === void 0 ? void 0 : filters.includeActorFilter) && {
              includeActor: Array.from((_filters$includeActor = filters.includeActorFilter) !== null && _filters$includeActor !== void 0 ? _filters$includeActor : [])
            }), (filters === null || filters === void 0 ? void 0 : filters.excludeActorFilter) && {
              excludeActor: Array.from((_filters$excludeActor = filters.excludeActorFilter) !== null && _filters$excludeActor !== void 0 ? _filters$excludeActor : [])
            }),
            requestInit: {
              credentials: 'include',
              headers: {
                'content-type': 'application/json',
                'x-app-name': packageName,
                'x-app-version': packageVersion,
                'x-app-platform': 'web'
              },
              method: 'POST',
              body: JSON.stringify({
                toState: MarkRequestReadState.READ
              })
            },
            // @ts-ignore
            ignoreResponsePayload: true
          };
          _context.next = 5;
          return utils.requestService({
            url: markAllApiRoute
          }, requestServiceOptions);
        case 5:
          return _context.abrupt("return", _context.sent);
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function markAllNotificationsReadFetch(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();